import { Flex, rebrandedIbisVisionLogo, Icon } from '../../2022-component-library';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const shine = keyframes`
0% {
   background-position: right;
  }
  `;

const ShineOverlay = styled(Flex)`
  height: 100%;
  width: 100%;
  margin: 5px;
  position: absolute;
  background: linear-gradient(90deg, #0000 33%, rgba(255, 255, 255, 0.3) 50%, #0000 66%);
  background-size: 300% 100%;
  animation: ${shine} 1s infinite;
  z-index: 10;
`;

const ResponsiveLoadingPage = () => {
  return (
    <Flex width='100vw' height='100vh' centered column>
      <Flex position='relative'>
        <Icon icon={rebrandedIbisVisionLogo} marginBottom='2rem' zIndex='1' width='175px' />
        <ShineOverlay />
      </Flex>
    </Flex>
  );
};

export default ResponsiveLoadingPage;
